export const ComparatorFieldProp = Object.freeze({
    Options: 'options',
    Value: 'value',
});
